const RECENT_KEY = 'recent_tools';

// Storage can throw in a private window. The list then opens without recents.
export function readRecent(): string[] {
  try {
    const paths = JSON.parse(localStorage.getItem(RECENT_KEY) ?? '[]');
    return Array.isArray(paths) ? paths.filter((path): path is string => typeof path === 'string') : [];
  } catch {
    return [];
  }
}

export function writeRecent(paths: string[]) {
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(paths));
  } catch {}
}
